import { useDashboardContext } from './DashboardContext';

export const usePageLocation = () => {
  const dashboardContext = useDashboardContext();

  if (!dashboardContext) {
    throw new Error(
      'Cannot get dashboard context for usePageLocation. Please wrap your Page component with `withDashboard` HOC',
    );
  }
  return dashboardContext.location;
};
